var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-pdf-embed',{attrs:{"source":`${_vm.source}`},on:{"loading-failed":_vm.handleDocumentFailed,"loaded":_vm.handleDocumentLoad}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }